import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  Data,
  MonthlyDetail,
} from '@base/src/app/pages/configuration/panel/configuration.component';
import { QRInput } from 'src/app/models/qr-input.model';
import {
  DecimalAmountField,
  DecimalAmountInput,
} from '@base/src/app/utils/decimal-amount.utils';

interface MonthlyObjectiveEntry {
  key: string;
  label: string;
  amount: DecimalAmountField;
  ponderation: number;
}

const MONTHS = [
  { key: 'january', label: 'Enero' },
  { key: 'february', label: 'Febrero' },
  { key: 'march', label: 'Marzo' },
  { key: 'april', label: 'Abril' },
  { key: 'may', label: 'Mayo' },
  { key: 'june', label: 'Junio' },
  { key: 'july', label: 'Julio' },
  { key: 'august', label: 'Agosto' },
  { key: 'september', label: 'Septiembre' },
  { key: 'october', label: 'Octubre' },
  { key: 'november', label: 'Noviembre' },
  { key: 'december', label: 'Diciembre' },
];

@Component({
  selector: 'app-config-objectives-detailed',
  templateUrl: './config-objectives-detailed.component.html',
  styleUrls: ['./config-objectives-detailed.component.scss'],
})
export class ConfigObjectivesDetailedComponent implements OnInit {
  @Input() value!: MonthlyDetail;

  @Output() change: EventEmitter<Data> = new EventEmitter<Data>();

  isEdit = true;

  input: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '0',
    debounceTime: 0,
  };

  annual = new DecimalAmountField(0);
  months: MonthlyObjectiveEntry[] = [];

  ngOnInit(): void {
    this.isEdit = this.value.data.updateObjectives ?? false;
    this.generateFormat();
  }

  generateFormat() {
    this.annual = new DecimalAmountField(this.value.data.anual);
    this.value.data.anual = this.annual.value;

    this.months = MONTHS.map((month, index) => {
      const VAL = this.value.data[month.key];
      return {
        ...month,
        amount: new DecimalAmountField(
          typeof VAL === 'number' || typeof VAL === 'string' ? VAL : 0
        ),
        ponderation: (this.value.ponderations?.[index]?.ponderation ?? 0) / 100,
      };
    });
  }

  trackByMonthKey(_index: number, month: MonthlyObjectiveEntry): string {
    return month.key;
  }

  onAnnualInput(event: DecimalAmountInput) {
    this.annual.onInput(event);
  }

  commitAnnualValue() {
    if (!this.annual.commit()) return;

    this.months.forEach((month) => {
      month.amount.set(this.annual.value * month.ponderation);
    });
    this.saveData();
  }

  onMonthInput(event: DecimalAmountInput, month: MonthlyObjectiveEntry) {
    month.amount.onInput(event);
  }

  commitMonthValue(month: MonthlyObjectiveEntry) {
    if (!month.amount.commit()) return;

    this.annual.set(
      this.months.reduce((acc, m) => acc + m.amount.value, 0)
    );
    this.saveData();
  }

  saveData() {
    this.value.data.anual = this.annual.value;
    this.months.forEach((month) => {
      this.value.data[month.key] = month.amount.value;
    });
    this.change.emit(this.value.data);
  }
}
